import { Injectable, Injector } from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';

import { AuthenticationService } from '../authentication/authentication.service';

@Injectable ()
export class LanguageInterceptor implements HttpInterceptor {
	constructor (private authenticationService: AuthenticationService) {}
	
	intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
		const list = {
			vn : "vn",
			en : "en",
			th : "th",
			id : "id",
			}
			
		const language = this.authenticationService.getData("language");
		
		const modifiedReq = req.clone({
			headers: req.headers.set('Language', `${list[language]}`),
		});
		return next.handle(modifiedReq);
	}
}
